// import React from "react";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Badge, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMapContext } from "../../context/map.context";
import { DateUtil } from "../../utils/date.util";
import { ExportTable } from "../Tables/ExportTable";
import { DevicesTableModel } from "../../models/tables.model";
import { DeviceConnectivityStatusEnum, EMPTY_DATA_DASH } from "../../constants";
import './table.css'
import { orderBy } from "lodash";

function repleaceDeviceConnectionStatus(status) {
  switch (status) {
    case DeviceConnectivityStatusEnum.Online:
      return "Online";
    case DeviceConnectivityStatusEnum.Offline:
      return "Offline";
    case DeviceConnectivityStatusEnum.Reachable:
      return "Reachable";
    default:
      return "Not Tracked";
  }
}

function repleaceDeviceConnectionStatusTooltip(status) {
  switch (status) {
    case DeviceConnectivityStatusEnum.Online:
      return "Device is connected";
    case DeviceConnectivityStatusEnum.Offline:
      return "Device is not connected";
    case DeviceConnectivityStatusEnum.Reachable:
      return "Device status is not tracke";
    default:
      return "Device status is not tracked";
  }
}

function repleaceDeviceConnectionStatusBgColor(status) {
  switch (status) {
    case DeviceConnectivityStatusEnum.Online:
      return "success";
    case DeviceConnectivityStatusEnum.Offline:
      return "danger";
    case DeviceConnectivityStatusEnum.Reachable:
      return "info";
    default:
      return "light";
  }
}

function getStaticColumns(devicesTableData, translateFunction) {

  const deviceOperatingStatus = (status) => {
    if (status === 0 || !status) return t("devices.deviceOperatingStatus.disabled")
    else if (status === 1) return t("devices.deviceOperatingStatus.enabled")
    //else return "Device is not tracked"
  }

  const getStatusBadge = (status, time) => {

    const TooltipComponent = (status) => {
      return (
        <Tooltip>
          <span className="wd-65p tx-left" style={{ color: "white" }}>
            {repleaceDeviceConnectionStatusTooltip(status)}
          </span>
        </Tooltip>
      )
    }

    return (
      <Col lg={10}>
        <Row>
          <OverlayTrigger placement="top" overlay={TooltipComponent(status)} /*  onEntering={entering} */>
            <Badge pill bg={repleaceDeviceConnectionStatusBgColor(status)} className="mg-x-auto">
              {repleaceDeviceConnectionStatus(status)}
            </Badge>
          </OverlayTrigger>
        </Row>
      </Col>
    );
  };

  const getTimeAgo = (time) => {

    const lastSuccessPingTimeAgo = !time ? "" : DateUtil.formatTimeAgo(time)

    const tooltipComponent = (
      <Tooltip>
        <span className="wd-65p tx-left" style={{ color: "white" }}>
          {DateUtil.convertDateStringToBackendDateString(time)}
        </span>
      </Tooltip>
    )

    return (
      <OverlayTrigger placement="top" overlay={tooltipComponent} >
        <div>{lastSuccessPingTimeAgo}</div>
      </OverlayTrigger>
    )
  };

  //https://react.spruko.com/spruha/preview/advanceUI/userlist/
  const columns = [
    {
      name: DevicesTableModel.Status,
      //selector: (row) => [row[name]],
      selector: (row) => row[DevicesTableModel.ConnectivityStatus],
      sortable: true,
      grow: 1,
      cell: (row) => getStatusBadge(row[DevicesTableModel.ConnectivityStatus], row[DevicesTableModel.Time]),
      center: true
    },
    {
      name: "Last checkup",
      grow: 1,
      selector: (row) => row[DevicesTableModel.Time],
      //cell: (row) => <div>{row[DevicesTableModel.Time] ? DateUtil.convertDateStringToBackendDateString(row[DevicesTableModel.Time]) : EMPTY_DATA_DASH}</div>,
      cell: (row) => <div>{row[DevicesTableModel.Time] ? getTimeAgo(row[DevicesTableModel.Time]) : EMPTY_DATA_DASH}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.OperatorId,
      grow: 1,
      selector: (row) => row[DevicesTableModel.OperatorId],
      cell: (row) => <div className="font-weight-bold">{row[DevicesTableModel.OperatorId]}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.DeviceID,
      grow: 0,
      selector: (row) => row[DevicesTableModel.DeviceID],
      cell: (row) => <div className="font-weight-bold">{row[DevicesTableModel.DeviceID]}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.City,
      grow: 0,
      selector: (row) => row[DevicesTableModel.City],
      cell: (row) => <div className="font-weight-bold">{row[DevicesTableModel.City] === "" ? EMPTY_DATA_DASH : row[DevicesTableModel.City]}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.Address,
      grow: 1,
      selector: (row) => row[DevicesTableModel.Address],
      cell: (row) => <div className="font-weight-bold">{row[DevicesTableModel.Address] === "" ? EMPTY_DATA_DASH : row[DevicesTableModel.Address]}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.SoftwareVersion,
      grow: 1,
      selector: (row) => row[DevicesTableModel.SoftwareVersion],
      cell: (row) => <div>{row[DevicesTableModel.SoftwareVersion] === "" ? EMPTY_DATA_DASH : row[DevicesTableModel.SoftwareVersion]}</div>,
      sortable: true,
    },
    {
      name: DevicesTableModel.OperatingStatus,
      grow: 2,
      selector: (row) => row[DevicesTableModel.OperatingStatus],
      cell: (row) => <div>{deviceOperatingStatus(row[DevicesTableModel.OperatingStatus])}</div>,
      sortable: true,
    },
    /* {
      name: DevicesTableModel.ConnectivityStatus,
      grow: 1,
      //selector: (row) => row[DevicesTableModel.Information],
      cell: (row) => <div>{deviceConnectivityStatus(row[DevicesTableModel.ConnectivityStatus])}</div>,
      sortable: true,
    }, */
    {
      name: "ACTION",
      cell: (row) => <Link to={`details/${row[DevicesTableModel.DeviceID]}`}>{translateFunction("general.Details")}</Link>,
    },
  ];

  return columns;
}

const sortBasedOnColumnName = (rows, selector, direction) => {
  return orderBy(
    rows,
    [
      (row) => {
        const value = selector(row);
        console.log(value)
        const isEmpty = value === null || value === undefined || value === "" || value === EMPTY_DATA_DASH;

        return isEmpty ? (direction === "asc" ? "\uffff" : "\x00") : value.toString();      
      },
    ],
    [direction]
  );
}

export function DevicesTable({ dataForTable }) {
  const { t: translate } = useTranslation();
  const { onTableDevicesClick } = useMapContext();

  const dataFromProps = [...dataForTable]

  const columns = getStaticColumns(dataFromProps, translate);

  const tableData = {
    columns,
    data: dataFromProps,
  };

  return (
    // DataTableExtensions => (AddOn Lib for Search & Export)
    <ExportTable tableData={dataFromProps}>
      <DataTableExtensions {...tableData}>
        <DataTable
          className="custom-data-table"
          columns={tableData.columns}
          data={tableData.data}
          defaultSortAsc={false}
          sortFunction={sortBasedOnColumnName}
          center={true}
          pagination
          highlightOnHover
          onRowClicked={onTableDevicesClick} />
      </DataTableExtensions>
    </ExportTable>
  );
}
